
import { writable } from 'svelte/store';

export const logado = writable(false);

// Função para atualizar o valor de logado
export function atualizarLogado(novoValor) {
    logado.set(novoValor);
}
